import * as http from './http';
import {
  ApiResponse,
  Customer,
  PaginatedApiResponse,
  ListSort,
} from '../models';
import ApiService from './service';
import { Dict } from '../../models';

export class MonthEndClosingService extends ApiService {
  public async createMonthEndClosing(data: {
    month: string;
    startDate: Date;
    endDate: Date;
    monthIndex: number;
  }) {
    const url = `${this.apiDomain}/api/month-end-closing/`;

    const response = await http.post<ApiResponse<Customer>>(
      url,

      data,
      this.store
    );

    return response?.data?.data;
  }

  public async getMonthEndingClosings(
    data: {
      page: number;
      search?: string;
      perPage: number;
      isDeal?: boolean;
      customerId?: string;
    } & ListSort &
      Dict
  ): Promise<PaginatedApiResponse<Customer> & { lastUpdatedAt: Date }> {
    const url = `${this.apiDomain}/api/month-end-closing/all`;

    const resposne = await http.post<PaginatedApiResponse<Customer>>(
      url,
      data,
      this.store
    );

    return { ...resposne.data, lastUpdatedAt: new Date() };
  }

  public async downloadMonthEndClosings(
    data: {
      search?: string;
      columns: { label: string; source?: string }[];
      isDeal?: boolean;
    } & ListSort &
      Dict
  ): Promise<void> {
    const url = `${this.apiDomain}/api/month-end-closing/list/download`;

    const resposne = await http.downloadPostData(url, data, this.store);
    http.saveDownloadedFile(
      resposne.data,
      'application/application/vnd.openxmlformats',
      `Month-End-Closings-${new Date()}.xlsx`
    );
  }
}
